import React from "react";
import "../style.scss";
import { withStyles, Avatar, Grid } from "@material-ui/core";
import {
  DRIVER_EVENTS,
  SHOW_DRIVER_LOGGED_STATUS,
} from "../../../modules/Dispatch/RouteExecution/constants";
import { getDriverStatus } from "../../../modules/Dispatch/RouteExecution/utils/DriverStatus/index";
import { getDriverStatusIcon } from "../../../modules/Dispatch/RouteExecution/utils/DriverStatus/driverStatusIcon";
import {
  getStopArrivalTime,
  getActiveStop,
  hasStopDelayed,
} from "../../../modules/Dispatch/RouteExecution/utils";
import Message from "./MessageIcon";
import appConstants from "../../../../appConstants";
import {getNextStop} from "../DispatchMap/utils"
import { LabeledToggle } from "../../../common/MUI";

const styles = (theme) => ({
  popupContainer: {
    minWidth: 360,
    backgroundColor: theme.ModalBGColor,
    height: "100%",
    width: "100%",
    padding: "15px",
  },
  tableHeadHeight: {
    height: "30px",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  tableRowRoot: {
    paddingTop: "8px",
  },
  tableRowLabelCell: {
    fontSize: theme.textFontSize,
    borderBottom: "none",
    color: theme.iconColor,
  },
  tableRowValueCell: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    borderBottom: "none",
    color: theme.ColumnHeaderTextColor,
  },
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
  },
  driverNumber: {
    color: theme.ColumnHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
  lastTableCell: {
    paddingBottom: 8,
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",   
    fontSize: theme.dispatchCardTextFontSize,
  },
  iconStyle: {
    paddingRight: 5,
  },
  avatar: {
    color: theme.iconColor,
    backgroundColor: theme.ModalBGColor,
    border: `1px solid ${theme.iconColor}`,
    width: 14,
    height: 14,
    fontSize: theme.dispatchCardTextFontSize,
  },
  pickupStopAvatar: {
    borderRadius: "3px",
  }
});
class DriverIconPopup extends React.Component {
  constructor(props) {
    super(props);
  }

  isArrivedAtOrEnrouteStop = (driverStatus) => {
    return [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      driverStatus
    );
  };

  getEtaTime = (driverStatus, currentStop, nextStop) => {
    const activeStop = this.isArrivedAtOrEnrouteStop(driverStatus)
      ? currentStop
      : nextStop;
    if (activeStop) {
      const isDelayed = hasStopDelayed(activeStop);
      const arrivalTime = getStopArrivalTime(driverStatus, activeStop);
      return isDelayed ? `${arrivalTime} (Delayed)` : arrivalTime;
    }
    return null;
  };

  getCurrentStatus = (driverStatus, currentStop) => {
    return getDriverStatusIcon({
      driverStatus,
      currentStop,
      color: this.props.theme.iconColor
    });
  };

  render() {
    const { classes, data, onMessageIconClick, onShowActualRouteToggleClick, showActualRoute, enableDriverActualRoute } = this.props;
    const { driverStatus, driverStatusLabel } = getDriverStatus(
      this.props,
      false
    );
    const currentStop = getActiveStop(data);
    const nextStop = getNextStop(this.props.data.stops);
    const driverStatusIcon = this.getCurrentStatus(driverStatus, currentStop);
    const etaTime = this.getEtaTime(driverStatus, currentStop, nextStop);
    return (
      <div className={classes.popupContainer}>
        <Grid container item xs>
          <Grid item container xs={12} className={classes.tableHeadHeight}>
            <Grid item xs={8}>
              <span className={classes.tableRow}>
                <span className={classes.driverName}>{data?.driverName}</span>
                {onMessageIconClick && (
                  <Message
                    onClick={onMessageIconClick}
                    driverId={data?.driverId}
                  />
                )}
              </span>
            </Grid>
            <Grid item xs={4} align="right" className={classes.driverNumber}>
              #{data?.driverNumber}
            </Grid>
          </Grid>
         {data.loggedInStatus && <Grid item container xs={12} className={classes.tableRowRoot}>
            <Grid item xs={4} className={classes.tableRowLabelCell}>
              Driver Login Status:
            </Grid>
            <Grid
              item
              xs={8}
              align="right"
              className={classes.tableRowValueCell}
            >
              {SHOW_DRIVER_LOGGED_STATUS[data.loggedInStatus]}
            </Grid>
          </Grid>}
          <Grid item container xs={12} className={classes.tableRowRoot}>
            <Grid item xs={3} className={classes.tableRowLabelCell}>
              Trailer Type:
            </Grid>
            <Grid
              item
              xs={9}
              align="right"
              className={classes.tableRowValueCell}
            >
              {data?.trailerName}
            </Grid>
          </Grid>
          {driverStatusLabel && (
            <Grid item container xs={12} className={classes.tableRowRoot}>
              <Grid item xs={3} className={classes.tableRowLabelCell}>
                Current Status:
              </Grid>
              <Grid
                item
                xs={9}
                align="right"
                className={classes.tableRowValueCell}
              >
                <div className={classes.statusRow}>
                  <span className={classes.iconStyle}>{driverStatusIcon}</span>
                  {driverStatusLabel}
                </div>
              </Grid>
            </Grid>
          )}
          {nextStop && (
            <Grid item container xs={12} className={classes.tableRowRoot}>
              <Grid item xs={3} className={classes.tableRowLabelCell}>
                Next Stop:
              </Grid>
              <Grid
                item
                xs={9}
                align="right"
                className={classes.tableRowValueCell}
              >
                <div className={classes.statusRow}>
                  <span className={classes.iconStyle}>
                    <Avatar
                      className={`${classes.avatar} ${
                        nextStop.stopType === appConstants.STOP_TYPE.Pickup
                          ? classes.pickupStopAvatar
                          : ""
                      }`}
                    >
                      {nextStop.stopSequence}
                    </Avatar>
                  </span>
                  {nextStop.name}
                </div>
              </Grid>
            </Grid>
          )}
          {nextStop && (
            <Grid item container xs={12} className={classes.tableRowRoot}>
              <Grid item xs={3} className={classes.tableRowLabelCell}>
                ETA:
              </Grid>
              <Grid
                item
                xs={9}
                align="right"
                className={classes.tableRowValueCell}
              >
                {etaTime}
              </Grid>
            </Grid>
          )}
          {enableDriverActualRoute && <Grid item container xs={12} className={classes.tableRowRoot}>
            <Grid item xs={12}>
             <LabeledToggle label="Show Actual Driver Route" onChange={(checked) => onShowActualRouteToggleClick(data,checked)} checked={showActualRoute}/>
            </Grid>
          </Grid>}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(DriverIconPopup);
